// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"6e0bcfc2","651":"dce38705"}[chunkId] + ".chunk.js";
};